<template>
  <div class="row">
    <div class="col-md-12">
      <b-card>
        <ValidationObserver ref="formObserver" v-slot="{ validate }">
          <b-form @submit.prevent="handleSubmit(validate)">
            <ValidationProvider name="Nome" rules="required" v-slot="{ errors }">
              <b-form-group label="Nome" label-for="nome">
                <b-form-input
                    id="nome"
                    v-model="form.nome"
                    :state="errors.length ? false : null"
                    placeholder="Digite o nome do grupo"
                />
                <b-form-invalid-feedback>{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
            </ValidationProvider>

            <b-form-group label="Grupo Pai (opcional)" label-for="parent_id">
              <v-select
                  id="parent_id"
                  v-model="form.parent_id"
                  :options="parentOptions"
                  :label="'path'"
                  :reduce="option => option.id"
                  placeholder="Selecione um grupo pai"
                  :clearable="true"
              />
            </b-form-group>

            <b-form-group label="Status" label-for="status">
              <b-form-select
                  id="status"
                  v-model="form.status"
                  :options="statusOptions"
              />
            </b-form-group>

            <div class="d-flex justify-content-end">
              <b-button variant="outline-secondary" class="mr-2" @click="$router.push('/manual-grupos')">
                Voltar
              </b-button>
              <b-button type="submit" variant="primary" :disabled="isLoading">
                <span v-if="isLoading"><i class="fas fa-spinner fa-spin mr-1"></i>Salvando...</span>
                <span v-else>Salvar</span>
              </b-button>
            </div>
          </b-form>
        </ValidationObserver>
      </b-card>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import vSelect from 'vue-select';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import {
  BCard,
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BFormSelect,
  BButton,
} from 'bootstrap-vue';

export default {
  name: 'ManualGrupoAdd',
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
    BCard,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BFormSelect,
    BButton,
  },
  data() {
    return {
      isLoading: false,
      isEdit: false,
      manualGrupoId: null,
      form: {
        nome: '',
        parent_id: null,
        status: 1,
      },
      parentOptions: [],
      statusOptions: [
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
    };
  },
  mounted() {
    this.manualGrupoId = this.$route.params.id;
    this.isEdit = !!this.manualGrupoId;

    this.getParentOptions().then(() => {
      if (this.isEdit) {
        this.getManualGrupo(this.manualGrupoId);
      }
    });
  },
  methods: {
    async handleSubmit(validate) {
      const valid = await validate();
      if (!valid) return;

      this.save();
    },

    getParentOptions() {
      return axios
          .get(this.$store.state.api + 'manual-grupos/options')
          .then(response => {
            const data = response.data.data || response.data || [];
            this.parentOptions = Array.isArray(data) ? data : [];
          })
          .catch(() => {
            this.parentOptions = [];
          });
    },

    getManualGrupo(id) {
      return axios
          .get(this.$store.state.api + 'manual-grupos/' + id)
          .then(response => {
            const raw = response.data.data || response.data;
            const group = Array.isArray(raw) ? raw[0] : raw;

            this.form.nome = group.nome || '';
            this.form.parent_id = group.parent_id || null;
            this.form.status = group.status ? 1 : 0;

            this.parentOptions = this.parentOptions.filter(option => option.id !== Number(id));
          })
          .catch(() => {
            this.$message('Erro', 'Erro ao carregar grupo de manual', 'error');
          });
    },

    save() {
      let api = this.$store.state.api + 'manual-grupos';
      let method = 'post';

      if (this.isEdit) {
        api += '/' + this.manualGrupoId;
        method = 'put';
      }

      this.isLoading = true;
      axios[method](api, this.form)
          .then(() => {
            this.$message('Sucesso', 'Grupo de manual salvo com sucesso', 'success');
            this.$router.push('/manual-grupos');
          })
          .catch(error => {
            const message = error?.response?.data?.message || 'Erro ao salvar grupo de manual';
            this.$message('Erro', message, 'error');
          })
          .finally(() => {
            this.isLoading = false;
          });
    },
  },
};
</script>
